import ConsumerRefService from "@api/consumer/consumerRefService";
import {EditRefForm, RefRewardsList, RefTargetsList} from "@components/consumer/refs";
import withPage from "@components/hoc/withPage";
import {useBreadcrumbs, useStateLoader} from "@hooks/panelHooks";
import {IRef} from "@interfaces/consumer/refs";
import {FC, useCallback} from "react";
import {NavLink, Route, Routes, useParams} from "react-router";
import {Nav, Row, Tab} from "react-bootstrap";
import {FormPageHeader} from "@components/falcon/common/forms";

const EditRefPage: FC = () => {

    const {ref_id} = useParams<{ ref_id: string }>();

    const loadRef = useCallback((ref_id: string) => {
        const api = new ConsumerRefService();
        return api.getRef(ref_id);
    }, []);

    const {data: ref} = useStateLoader<IRef>(loadRef, ref_id);
    useBreadcrumbs('consumer.refs.current.name', false, ref?.name);

    if (!ref) {
        return null;
    }

    return (
        <>
            <Row className="g-3 m-0">
                <FormPageHeader title={`Редактирование реферального бонуса "${ref.name}"`} />
            </Row>
            <Tab.Container defaultActiveKey="basic">
                <Nav variant="tabs" className="mb-3">
                    <Nav.Item>
                        <NavLink to={`/consumer/refs/${ref_id}/`} className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} replace end>
                            Основное
                        </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                        <NavLink to={`/consumer/refs/${ref_id}/targets/`} className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} replace>
                            Цели
                        </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                        <NavLink to={`/consumer/refs/${ref_id}/rewards/`} className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} replace>
                            Награды
                        </NavLink>
                    </Nav.Item>
                </Nav>
                <Routes>
                    <Route path="/" element={<EditRefForm refObj={ref} />} />
                    <Route path="/targets" element={<RefTargetsList />} />
                    <Route path="/rewards" element={<RefRewardsList />} />
                </Routes>
            </Tab.Container>
        </>
    )
}

export default withPage(EditRefPage);
